import { v4 } from '@lukeed/uuid';
import { setIDs } from '../peaks/util/setIDs';
import { signalsToRanges } from '../signals/signalsToRanges';
import { fetchPrediction } from './utils/fetchPrediction';
import { queryByHose } from './utils/queryByHOSE';
function checkFromPrediction(signal) {
    if (!signal.atoms)
        throw new Error('There is not atoms');
    if (!signal.diaIDs)
        throw new Error('There is not diaIDs');
    if (!signal.nbAtoms)
        throw new Error('There is not nbAtoms');
}
/**
 * Make a query to a hose code based database to predict carbon chemical shift
 * @returns {Promise<object>} - object with molfile, diaIDs, signals, joined signals by diaIDs and ranges.
 */
export async function predictCarbon(topicMolecule, options = {}) {
    const { database, webserviceURL = 'https://nmr-prediction.service.zakodium.com/v1/predict/carbon', } = options;
    if (topicMolecule.molecule.getAllAtoms() === 0) {
        return {
            nucleus: '13C',
            joinedSignals: [],
            signals: [],
            ranges: [],
        };
    }
    if (!database) {
        const molfile = topicMolecule.toMolfile();
        return fetchPrediction(molfile, { webserviceURL });
    }
    const maxLevel = database.length - 1;
    let { maxSphereSize = maxLevel } = options;
    if (maxSphereSize > maxLevel)
        maxSphereSize = maxLevel;
    const hoseCodes = topicMolecule.hoseCodes;
    const diaIDsWithInfo = topicMolecule.diaIDsAndInfo.map((entry, index) => ({
        ...entry,
        hoses: hoseCodes[index],
    }));
    const predictions = queryByHose(diaIDsWithInfo, database, {
        maxSphereSize,
        atomLabel: 'C',
    });
    const signals = formatSignals(predictions);
    const joinedSignals = joinSignalByDiaID(signals);
    return {
        nucleus: '13C',
        joinedSignals,
        signals,
        ranges: signalsToRanges(joinedSignals),
    };
}
function formatSignals(predictions) {
    const signals = [];
    for (const prediction of predictions) {
        const { nbAtoms, atoms, delta, diaIDs, statistic } = prediction;
        const signal = {
            id: v4(),
            delta: delta ?? NaN,
            atoms,
            diaIDs,
            multiplicity: 's',
            nbAtoms,
            statistic,
            js: [],
        };
        signals.push(signal);
    }
    return signals;
}
function joinSignalByDiaID(signals) {
    const joinedSignals = {};
    for (const signal of signals) {
        checkFromPrediction(signal);
        const diaID = signal.diaIDs[0];
        if (!joinedSignals[diaID]) {
            joinedSignals[diaID] = JSON.parse(JSON.stringify(signal));
        }
        else {
            joinedSignals[diaID].nbAtoms += signal.nbAtoms;
            joinedSignals[diaID].atoms.push(...signal.atoms);
        }
    }
    return setIDs(Object.values(joinedSignals));
}
//# sourceMappingURL=predictCarbon.js.map